var map = {
	"./corporate/kita_1_ocular.jpg": "5829",
	"./corporate/kita_2_ocular.jpg": "7530",
	"./corporate/kita_3_ocular.jpg": "2573",
	"./corporate/kita_4_ocular.jpg": "03b0",
	"./corporate/kita_5_ocular.jpg": "4d4d",
	"./corporate/kita_6_ocular.jpg": "3c7d",
	"./corporate/schreiner_ocular.jpg": "1cc5",
	"./corporate/spengler_1_ocular.jpg": "37ff",
	"./corporate/spengler_2_ocular.jpg": "c03f",
	"./corporate/spengler_3_ocular.jpg": "9c76",
	"./events/hochzeit_kuss_ocular.jpg": "c7df",
	"./events/hochzeit_paarfoto-auto_ocular.jpg": "0b8a",
	"./events/hochzeit_paarfoto_ocular.jpg": "0ba7",
	"./events/hochzeit_rede_ocular.jpg": "b3d3",
	"./events/hochzeit_tanz_ocular.jpg": "ea0b",
	"./events/hochzeit_zeremonie_ocular.jpg": "d75d",
	"./events/paarfoto_antrag_ocular.jpg": "1c7f",
	"./events/paarfoto_kuss_ocular.jpg": "1b3a",
	"./events/paarfoto_ocular.jpg": "d20e",
	"./events/paarfoto_regenschirm-jump_ocular.jpg": "dd13",
	"./events/paarfoto_regenschirm-kuss_ocular.jpg": "914c",
	"./events/paarfoto_regenschirm_ocular.jpg": "970e",
	"./portrait/andrin_bern_regen_ocular.jpg": "8bf4",
	"./portrait/andrin_thunersee_surfen_ocular.jpg": "6e84",
	"./portrait/beliz_münster_bern_ocular.jpg": "e091",
	"./portrait/cyril_ocular.jpg": "f28a",
	"./portrait/debi_parkhaus_ocular-2.jpg": "2f6e",
	"./portrait/debi_parkhaus_ocular.jpg": "1935",
	"./portrait/elena&leona_parkhaus_ocular.jpg": "c81a",
	"./portrait/elena_biel_ocular.jpg": "2014",
	"./portrait/elena_parkhaus_ocular.jpg": "b942",
	"./portrait/emporia_bern_compressed_ocular.jpg": "676e",
	"./portrait/emporia_bern_ocular-2.jpg": "8c06",
	"./portrait/emporia_bern_ocular.jpg": "2a26",
	"./portrait/eric_biel_ocular-2.jpg": "24e8",
	"./portrait/eric_biel_ocular.jpg": "748e",
	"./portrait/eric_pink-tuerkis_ocular.jpg": "31b4",
	"./portrait/ermporia_blue-compressed_ocular.jpg": "91d8",
	"./portrait/francois_1_ocular.jpg": "fb7c",
	"./portrait/francois_2_ocular.jpg": "0dd9",
	"./portrait/francois_3_ocular.jpg": "28f8",
	"./portrait/jas-angelina_bern_ocular.jpg": "56a2",
	"./portrait/kim_ocular.jpg": "7c35",
	"./portrait/kim_tunesien_strand_ocular.jpg": "9d0d",
	"./portrait/laura_bern_ocular.jpg": "ec1f",
	"./portrait/leona_10_ocular.jpg": "0333",
	"./portrait/leona_1_ocular.jpg": "9c15",
	"./portrait/leona_2_ocular.jpg": "8172",
	"./portrait/leona_3_ocular.jpg": "4cdd",
	"./portrait/leona_4_ocular.jpg": "59c2",
	"./portrait/leona_5_ocular.jpg": "335a",
	"./portrait/leona_6_ocular.jpg": "682a",
	"./portrait/leona_8_ocular.jpg": "4222",
	"./portrait/leona_9_ocular.jpg": "3d26",
	"./portrait/leona_parkhaus_sitzend_ocular.jpg": "050f",
	"./portrait/leona_schnee_ocular.jpg": "d76c",
	"./portrait/leona_street_blätter_ocular.jpg": "2d60",
	"./portrait/leona_street_ocular.jpg": "5536",
	"./portrait/luka_claudio_rave_unscharf_ocular.jpg": "d668",
	"./portrait/mahe_1_ocular.jpg": "a8c3",
	"./portrait/mahe_2_ocular.jpg": "05c9",
	"./portrait/mahe_3_ocular.jpg": "0759",
	"./portrait/melissa_bern_ocular.jpg": "1579",
	"./portrait/pascal_luka_rave_ocular.jpg": "3cfd",
	"./portrait/pascal_thun_ocular-2.jpg": "0c1b",
	"./portrait/pascal_thun_ocular.jpg": "9680",
	"./portrait/tavi_biel_kamera_ocular.jpg": "7c51",
	"./portrait/tavi_biel_ocular.jpg": "f45d",
	"./portrait/timon_ocular.jpg": "6d9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe58";